var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pay-agreement-page"},[_c('common-title',{attrs:{"titleName":"购课须知","bcColor":'#FEFEFF',"zIndex":1000}}),_c('div',{staticClass:"content-center",domProps:{"innerHTML":_vm._s(_vm.agreement)}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }